export default [
  {
    name: 'CustomersFormConfigsCompaniesList',
    path: 'settings/companies/customers-form-configs',
    component: () => import('pages/settings/customers-form-configs/CustomersFormConfigsCompaniesList.vue')
  },
  {
    name: 'CustomersFormConfigsForm',
    path: 'settings/companies/:id/customers-form-configs/edit',
    component: () => import('pages/settings/customers-form-configs/CustomersFormConfigsForm.vue')
  }
]
